<template>
  <div class="page-wrapper">
    <a-breadcrumb style="margin: 16px 0">
      <a-breadcrumb-item>VOD维度</a-breadcrumb-item>
      <a-breadcrumb-item>社区平台舆情分析</a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 页面标题区 -->
    <div class="page-header">
      <h2 class="page-title">社区平台舆情分析</h2>
    </div>

    <!-- 统计概览卡片 -->
    <div class="stat-row">
      <div class="stat-card">
        <div class="stat-label">总文章数</div>
        <div class="stat-value">{{ originalTableData.length }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">涉及公众号</div>
        <div class="stat-value highlight-blue">{{ accountList.length }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">当前筛选结果</div>
        <div class="stat-value highlight-green">{{ filterTableData.length }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">高频关键词</div>
        <div class="stat-value highlight-orange">鸿蒙</div>
      </div>
    </div>

    <!-- 主内容卡片 -->
    <div class="content-card">
      <!-- 内容标题栏 -->
      <div class="card-header-bar">
        <div class="card-title-text">开源鸿蒙相关公众号文章汇总</div>
      </div>

      <!-- 筛选工具栏 -->
      <div class="toolbar">
        <!-- 账号过滤 Tab -->
        <div class="account-tabs">
          <button
            class="tab-btn"
            :class="{ active: selectedAccount === '' }"
            @click="selectedAccount = ''"
          >全部</button>
          <button
            v-for="acc in accountList"
            :key="acc"
            class="tab-btn"
            :class="{ active: selectedAccount === acc }"
            @click="selectedAccount = acc"
          >{{ acc }}</button>
        </div>
        <!-- 搜索框 -->
        <div class="search-box">
          <span class="search-icon">🔍</span>
          <input
            v-model="searchKey"
            class="search-input"
            placeholder="搜索文章标题..."
          />
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrap">
        <table class="data-table">
          <thead>
            <tr>
              <th style="width:60px;">序号</th>
              <th style="width:130px;">公众号名称</th>
              <th>文章标题</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, idx) in pagedData"
              :key="idx"
              :class="{ 'row-odd': idx % 2 === 0 }"
            >
              <td class="center-cell">{{ (currentPage - 1) * pageSize + idx + 1 }}</td>
              <td class="center-cell">
                <span class="account-tag">{{ row.accountName }}</span>
              </td>
              <td>
                <span class="title-cell" :title="row.articleTitle" v-html="row.articleTitle"></span>
              </td>
            </tr>
            <tr v-if="pagedData.length === 0">
              <td colspan="3" class="empty-cell">暂无数据</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分页 -->
      <div class="pagination-bar">
        <span class="page-info">共 {{ filterTableData.length }} 条</span>
        <div class="page-btns">
          <button class="page-btn" :disabled="currentPage === 1" @click="currentPage--">‹</button>
          <button
            v-for="p in displayedPages"
            :key="p"
            class="page-btn"
            :class="{ 'active': p === currentPage, 'ellipsis': p === '...' }"
            :disabled="p === '...'"
            @click="p !== '...' && (currentPage = p)"
          >{{ p }}</button>
          <button class="page-btn" :disabled="currentPage === totalPages" @click="currentPage++">›</button>
        </div>
        <span class="page-info">每页 {{ pageSize }} 条</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

const originalTableData = [{accountName:'深开鸿',articleTitle:'广东（东莞）应用场景创新大会举行，深开鸿助力东莞打造开源<em>鸿蒙</em>之城'},
{accountName:'深开鸿',articleTitle:'“开源<em>鸿蒙</em>校园行”走进龙岗区信义外国语学校'},
{accountName:'深开鸿',articleTitle:'深开鸿携手深高速基于开源<em>鸿蒙</em>打造全国首个立体复合智慧高速公路方案'},
{accountName:'深开鸿',articleTitle:'正式招生！2026年企业“开源<em>鸿蒙</em>南向设备开发”培训班启动'},
{accountName:'深开鸿',articleTitle:'深开鸿：以开源<em>鸿蒙</em>为基，深耕多场景，助力数字化转型'},
{accountName:'深开鸿',articleTitle:'开源<em>鸿蒙</em>+AI，深开鸿推动龙岗首个智慧康养示范场景落地！'},
{accountName:'深开鸿',articleTitle:'开源<em>鸿蒙</em>赋能智慧交通浦江S219路段实现安全管控新突破'},
{accountName:'深开鸿',articleTitle:'全国首个开源<em>鸿蒙</em>智慧病区正式启用，深开鸿携手深圳龙岗中心医院打造智慧医疗新标杆'},
{accountName:'深开鸿',articleTitle:'喜报！深开鸿与人才数科共建“开源<em>鸿蒙</em>开发者培训基地”入选深圳“数智治理与创新案例”'},
{accountName:'深开鸿',articleTitle:'“开放原子校源行师资培训系列——2026年开源<em>鸿蒙</em>北向应用开发与南向设备开发研修班”在深圳成功举办'},
{accountName:'深开鸿',articleTitle:'政企校三方协同，深开鸿向晋江市季延中学捐赠开源<em>鸿蒙</em>教育资源'},
{accountName:'深开鸿',articleTitle:'全国首个“<em>鸿蒙</em>AI数智机关”落地福田，深开鸿筑牢政务安全底座'},
{accountName:'深开鸿',articleTitle:'开源<em>鸿蒙</em>生态共建成势，深开鸿主干代码贡献量破650万行'},
{accountName:'深开鸿',articleTitle:'报名开启！2026年开源<em>鸿蒙</em>“北向应用”与“南向设备”开发研修班等你加入！'},
{accountName:'深开鸿',articleTitle:'福田区2026年首期开源<em>鸿蒙</em>专题培训圆满举办，政企共筑产业创新高地'},
{accountName:'深开鸿',articleTitle:'深开鸿开源<em>鸿蒙</em>社区代码贡献量破650万行！'},
{accountName:'深开鸿',articleTitle:'深开鸿荣获多项开源<em>鸿蒙</em>“年度价值商用案例”！'},
{accountName:'深开鸿',articleTitle:'<em>鸿蒙</em>星光盛典见证生态硕果！深开鸿斩获开源<em>鸿蒙</em>双项荣誉！'},
{accountName:'深开鸿',articleTitle:'“开源<em>鸿蒙</em>机器人方阵”入场秀惊艳亮相，M-RobotsOS引领城市智慧环卫变革'},
{accountName:'深开鸿',articleTitle:'开源<em>鸿蒙</em>赋能智慧交通：“冀鸿”打造隧道智能化新标杆'},
{accountName:'深开鸿',articleTitle:'深开鸿助力打造深圳首个面向开源<em>鸿蒙</em>的开发者培训基地'},
{accountName:'深开鸿',articleTitle:'深开鸿捐赠M-Robots项目，以开源<em>鸿蒙</em>统一底座推动机器人产业协同'},
{accountName:'深开鸿',articleTitle:'深开鸿亮相CEIC消费电子创新大会，以“开源<em>鸿蒙</em>+AI”重构美好生活新体验'},
{accountName:'深开鸿',articleTitle:'【马上报名】2025年深圳开源<em>鸿蒙</em>/RISC-V创新应用大赛正式启动'},
{accountName:'深开鸿',articleTitle:'注入开源<em>鸿蒙</em>基因，深开鸿携手深天使点燃大湾区“金种子”创新引擎'},
{accountName:'深开鸿',articleTitle:'划重点！一图速览浦江开源<em>鸿蒙</em>生态大会金句'},
{accountName:'深开鸿',articleTitle:'开源<em>鸿蒙</em>生态成果集中亮相浦江，展示技术赋能与产业共进新图景'},
{accountName:'深开鸿',articleTitle:'开源<em>鸿蒙</em>（金华）应用创新示范中心在浦江揭牌多方签约共建生态新格局'},
{accountName:'深开鸿',articleTitle:'开源<em>鸿蒙</em>耕植浦江，提升县域人工智能发展竞争力'},
{accountName:'深开鸿',articleTitle:'明日启幕！浦江开源<em>鸿蒙</em>大会亮点前瞻，预约直播锁定精彩！'},
{accountName:'深开鸿',articleTitle:'【诚邀参会】浦江开源<em>鸿蒙</em>生态大会启幕在即，携手共建数智浦江！'},
{accountName:'深开鸿',articleTitle:'深开鸿亮相开源<em>鸿蒙</em>技术大会2025，以核心技术共建开源生态新格局'},
{accountName:'深开鸿',articleTitle:'基于开源<em>鸿蒙</em>打造的公路机电操作系统获“茅以升科学技术特等奖”！'},
{accountName:'深开鸿',articleTitle:'深开鸿与深信大共建“教师工程实践与创新工作站”，共育开源<em>鸿蒙</em>生态人才'},
{accountName:'深开鸿',articleTitle:'开源<em>鸿蒙</em>驱动机器人与AI产业生态发展，M-RobotsOS正式开源'},
{accountName:'深开鸿',articleTitle:'郑州市人民政府与深开鸿签署战略合作协议，共建开源<em>鸿蒙</em>（中原）创新基地'},
{accountName:'深开鸿',articleTitle:'全国首个开源<em>鸿蒙</em>机器人操作系统M-RobotsOS正式开源'},
{accountName:'深开鸿',articleTitle:'深开鸿王成录：以七大使能厚植生态，推进开源<em>鸿蒙</em>全面落地'},
{accountName:'深开鸿',articleTitle:'速来报名！“开源<em>鸿蒙</em>北向应用开发”暑期师资培训班启动！'},
{accountName:'深开鸿',articleTitle:'诚邀报名|开源<em>鸿蒙</em>助力机器人与人工智能产业生态发展分论坛'},
{accountName:'深开鸿',articleTitle:'深开鸿与12所职业本科高校达成合作，共筑开源<em>鸿蒙</em>人才生态体系'},
{accountName:'深开鸿',articleTitle:'全国首个985高校开源<em>鸿蒙</em>微专业落地！深开鸿与华中科技大学联合培养智能信息系统人才'},
{accountName:'深开鸿',articleTitle:'开鸿开发板深度体验：从开源<em>鸿蒙</em>开发到AI场景实践'},
{accountName:'深开鸿',articleTitle:'深开鸿与深信大联合培养的首批开源<em>鸿蒙</em>工程师完成KCA认证考试'},
{accountName:'深开鸿',articleTitle:'超530万行！深开鸿的开源<em>鸿蒙</em>社区代码贡献量再创新高度！'},
{accountName:'深开鸿',articleTitle:'从“开发者孤岛”到“生态星河”：开鸿Bot如何重构开源<em>鸿蒙</em>开发体验'},
{accountName:'深开鸿',articleTitle:'深开鸿与内蒙古建筑职业技术学院签署战略合作协议，共筑开源<em>鸿蒙</em>产教融合新生态'},
{accountName:'深开鸿',articleTitle:'深开鸿亮相开源<em>鸿蒙</em>开发者大会，全维度赋能产业智能化升级'},
{accountName:'深开鸿',articleTitle:'深开鸿发布三大核心产品，全面加速开源<em>鸿蒙</em>生态建设'},
{accountName:'润开鸿',articleTitle:'共建地区开源生态新口岸，润开鸿签约成为广州白云区首批<em>鸿蒙</em>生态合作伙伴'},
{accountName:'润开鸿',articleTitle:'AWE2026|润开鸿参编OneConnect智家标准重磅发布，共促“开源<em>鸿蒙</em>+星闪”智家互联开放生态繁荣'},
{accountName:'润开鸿',articleTitle:'赋能龙华先进制造数智化，润开鸿共同见证<em>鸿蒙</em>生态（龙华）创新中心启用'},
{accountName:'润开鸿',articleTitle:'赛事预告|中国大学生计算机设计大赛——基于开源<em>鸿蒙</em>+边缘智能的物联网系统创新设计赛'},
{accountName:'润开鸿',articleTitle:'润开鸿出席开源<em>鸿蒙</em>产品开发供需对接会，分享城市开源<em>鸿蒙</em>落地建设路径'},
{accountName:'润开鸿',articleTitle:'润开鸿获<em>鸿蒙</em>生态“2025年度突出贡献单位”'},
{accountName:'润开鸿',articleTitle:'润开鸿联合承办“开放原子大赛——基于开源<em>鸿蒙</em>操作系统的AI应用开发大赛”决赛圆满落幕'},
{accountName:'润开鸿',articleTitle:'决赛路演结果公示|开放原子大赛：基于开源<em>鸿蒙</em>操作系统的AI应用开发大赛'},
{accountName:'润开鸿',articleTitle:'润开鸿深度参编《<em>鸿蒙</em>应用培训讲师能力评价标准》正式发布'},
{accountName:'润开鸿',articleTitle:'决赛路演结果公示|开放原子大赛：基于RISC-V和开源<em>鸿蒙</em>的AI应用开发大赛'},
{accountName:'润开鸿',articleTitle:'开启全新细分领域，润开鸿使能西部钻探钻井物联操作系统通过开源<em>鸿蒙</em>兼容性测评'},
{accountName:'润开鸿',articleTitle:'开源<em>鸿蒙</em>筑基中小学教育创新论坛圆满举办，共绘科技自立自强教育新图景'},
{accountName:'润开鸿',articleTitle:'润和软件与润开鸿闪耀<em>鸿蒙</em>生态人才大会2025，引领人才培养新范式'},
{accountName:'润开鸿',articleTitle:'决赛晋级名单公示|开放原子大赛：基于开源<em>鸿蒙</em>操作系统的原生AI应用开发大赛'},
{accountName:'润开鸿',articleTitle:'活动预告|2025<em>鸿蒙</em>生态人才大会·开源<em>鸿蒙</em>筑基中小学教育创新论坛，润开鸿与您相约武汉'},
{accountName:'润开鸿',articleTitle:'<em>鸿蒙</em>星光盛典|润开鸿聚焦<em>鸿蒙</em>数字底座新“智”融合，共探中国自主创新之路'},
{accountName:'润开鸿',articleTitle:'决赛晋级名单公示|开放原子大赛：基于RISC-V和开源<em>鸿蒙</em>的AI应用开发大赛'},
{accountName:'润开鸿',articleTitle:'重磅：教育部职业教育增补专业57个！润开鸿以基于开源<em>鸿蒙</em>的产教融合支撑开源、信创方向新专业建设'},
{accountName:'润开鸿',articleTitle:'润开鸿成功举办2025年基于开源<em>鸿蒙</em>的智能座舱师资培训，助力高校开源技术实践与教学能力提升'},
{accountName:'润开鸿',articleTitle:'<em>鸿蒙</em>星光盛典|润开鸿获开源<em>鸿蒙</em>社区“代码贡献TOP单位”与“跨平台框架共建先锋”殊荣'},
{accountName:'润开鸿',articleTitle:'润开鸿“开源<em>鸿蒙</em>+星闪”智能家居物联方案获评“2025年度RISC-V优秀产品与解决方案”'},
{accountName:'润开鸿',articleTitle:'润开鸿以“开源<em>鸿蒙</em>+AI”双轮驱动，共绘职教创新落地新蓝图'},
{accountName:'润开鸿',articleTitle:'开源筑基，数智赋能|润开鸿引领开源<em>鸿蒙</em>商业场景创新，闪耀2025开放原子开发者大会'},
{accountName:'润开鸿',articleTitle:'“科教融汇共育人才”江苏省开源<em>鸿蒙</em>课程建设研讨会成功举办'},
{accountName:'润开鸿',articleTitle:'CEIC2025|润开鸿参编《行业<em>鸿蒙</em>终端发展蓝皮书2025》重磅发布'},
{accountName:'润开鸿',articleTitle:'直播预告|开放原子大赛：基于RISC-V和开源<em>鸿蒙</em>的AI应用开发大赛宣讲（二期）'},
{accountName:'润开鸿',articleTitle:'知识赋能生态，润开鸿获KnowledgeSIG开源<em>鸿蒙</em>“知识贡献之星”表彰'},
{accountName:'润开鸿',articleTitle:'直播预告|开放原子大赛：基于开源<em>鸿蒙</em>的原生AI应用开发大赛宣讲（一期）'},
{accountName:'润开鸿',articleTitle:'拓展“开源<em>鸿蒙</em>+RISC-V”智能物联生态，润开鸿见证深圳市“开源<em>鸿蒙</em>/RISC-V”产业联盟成立'},
{accountName:'润开鸿',articleTitle:'直播预告|开放原子大赛：基于RISC-V和开源<em>鸿蒙</em>的AI应用开发大赛宣讲（一期）'},
{accountName:'润开鸿',articleTitle:'润开鸿受邀出席华为软件（成都）生态大会，以开源<em>鸿蒙</em>赋能区域软件产业强链突破'},
{accountName:'润开鸿',articleTitle:'赛事报名|开放原子大赛：基于开源<em>鸿蒙</em>操作系统的原生AI应用开发大赛'},
{accountName:'润开鸿',articleTitle:'润开鸿重磅发布DAYU300与DAYU600，入选开源<em>鸿蒙</em>面向PC场景及移动智能终端场景主干开发平台'},
{accountName:'润开鸿',articleTitle:'开源<em>鸿蒙</em>技术大会2025|润开鸿以创新研发成果，加速核心技术生态融合与应用实践'},
{accountName:'润开鸿',articleTitle:'精彩预告|开源<em>鸿蒙</em>技术大会2025：润开鸿邀您见证万物智联新未来'},
{accountName:'润开鸿',articleTitle:'政企共探开源<em>鸿蒙</em>产业布局，沈阳市和平区考察团参访润和软件与润开鸿'},
{accountName:'润开鸿',articleTitle:'聚力场景创新体验，润开鸿受邀出席<em>鸿蒙</em>生态大会2025'},
{accountName:'润开鸿',articleTitle:'活动预告|“新场景新体验”润开鸿与您相约<em>鸿蒙</em>生态大会2025'},
{accountName:'润开鸿',articleTitle:'润开鸿支持“2025全国青少年信息素养大赛总决赛——开源<em>鸿蒙</em>工程赛”圆满完赛'},
{accountName:'润开鸿',articleTitle:'赛事报名|开放原子大赛：基于RISC-V芯片和开源<em>鸿蒙</em>操作系统的AI应用开发大赛'},
{accountName:'润开鸿',articleTitle:'润开鸿发布全球首本“RISC-V+开源<em>鸿蒙</em>”南北向开发书籍'},
{accountName:'润开鸿',articleTitle:'润开鸿2025暑期开源<em>鸿蒙</em>场景开发实训|南京航空航天大学“应用+设备全场景开发实战营”圆满结营'},
{accountName:'润开鸿',articleTitle:'2025MWC上海|润开鸿以“开源<em>鸿蒙</em>+星闪”呈现信息科技教育智联新风向'},
{accountName:'润开鸿',articleTitle:'以开源<em>鸿蒙</em>支撑武汉关基行业创新，润开鸿亮相第三届软件创新发展大会'},
{accountName:'润开鸿',articleTitle:'OHDC.2025|破百万行！润开鸿开源<em>鸿蒙</em>主仓代码贡献量再创新高'},
{accountName:'润开鸿',articleTitle:'精彩预告|润开鸿与您相约开源<em>鸿蒙</em>开发者大会2025，共筑新“智”未来'},
{accountName:'润开鸿',articleTitle:'第85届中国教装展|润开鸿基于“开源<em>鸿蒙</em>+星闪”数字基座带来教育行业新“智”场景多元体验'},
{accountName:'润开鸿',articleTitle:'润开鸿量子点智检™以开源<em>鸿蒙</em>和AI引领医疗微生物检测技术革新'},
{accountName:'润开鸿',articleTitle:'润开鸿落子鄂尔多斯重磅开启量子点智检™——AI微生物精准检测项目，以开源<em>鸿蒙</em>开创医疗产业创新高地'},
{accountName:'润开鸿',articleTitle:'【精彩预告】开源<em>鸿蒙</em>×星闪|面向源师兄系列新品发布会，4月18日10:00线上不见不散'},
{accountName:'九联开鸿',articleTitle:'开源共建智启未来|开源<em>鸿蒙</em>开发者大会2025成功举办'},
{accountName:'九联开鸿',articleTitle:'九联开鸿当选全球智慧物联网联盟（GIIC）理事单位并出席首届<em>鸿蒙</em>生态大会HEC2024！'},
{accountName:'九联开鸿',articleTitle:'九联科技推出国内首款通过开源<em>鸿蒙</em>兼容性测评的路由器产品！'},
{accountName:'九联开鸿',articleTitle:'​首个<em>鸿蒙</em>生态创新中心在深隆重揭幕，开启<em>鸿蒙</em>生态新篇章！'},
{accountName:'九联开鸿',articleTitle:'探索智能电网新时代，开源<em>鸿蒙</em>赋能电力新能源'},
{accountName:'九联开鸿',articleTitle:'共建繁荣生态|九联开鸿与<em>鸿蒙</em>生态服务公司签署合作协议'},
{accountName:'开鸿智谷',articleTitle:'等你来战！TalkwebHouse@黑客松暨开源<em>鸿蒙</em>城市技术沙龙2026•长沙站报名火热进行中！'},
{accountName:'开鸿智谷',articleTitle:'拓维信息及旗下开鸿智谷亮相华为中国合作伙伴大会2026，“AI×<em>鸿蒙</em>”精彩抢先看！'},
{accountName:'开鸿智谷',articleTitle:'媒体关注|拓维信息及旗下开鸿智谷助推<em>鸿蒙</em>生态加快落地'},
{accountName:'开鸿智谷',articleTitle:'拓维信息及旗下开鸿智谷即将亮相华为中国合作伙伴大会2026，“AI×<em>鸿蒙</em>”精彩抢先看！'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷全新推出在鸿ClawBOT！重构开源<em>鸿蒙</em>智慧空间智能体验'},
{accountName:'开鸿智谷',articleTitle:'开源<em>鸿蒙</em>6.1Release版本正式发布，在鸿OS6.1率先完成升级适配！'},
{accountName:'开鸿智谷',articleTitle:'更热AI，共未来！启航2026，奋进“AI×<em>鸿蒙</em>”壮阔新程'},
{accountName:'开鸿智谷',articleTitle:'拓维信息携开鸿智谷揽获<em>鸿蒙</em>生态多项年度荣誉，以技术深耕与人才培育驱动生态繁荣'},
{accountName:'开鸿智谷',articleTitle:'2026开放原子校源行师资培训暨全国开源<em>鸿蒙</em>技术应用开发寒假师资培训（湖南站）圆满落幕'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷助推<em>鸿蒙</em>生态星光学堂落地湖南高校，持续赋能区域<em>鸿蒙</em>人才体系建设'},
{accountName:'开鸿智谷',articleTitle:'<em>鸿蒙</em>生态·星光学堂<em>鸿蒙</em>应用开发者培训第1期（长沙）成功举办！政企协同共育<em>鸿蒙</em>人才，助力区域数字产业腾飞'},
{accountName:'开鸿智谷',articleTitle:'寒假充电|2026开放原子校源行开源<em>鸿蒙</em>技术应用开发师资培训邀您参加，湖南、江西、甘肃三地报名进行时！'},
{accountName:'开鸿智谷',articleTitle:'拓维信息携旗下开鸿智谷深度参与“<em>鸿蒙</em>生态人才大会2025”，以标准共建与生态合作引领人才培养新范式'},
{accountName:'开鸿智谷',articleTitle:'拓维信息及开鸿智谷助力长沙新一代信息技术公共实训基地正式启用，政校企协力共筑<em>鸿蒙</em>人才新高地'},
{accountName:'开鸿智谷',articleTitle:'AI为先，芯动未来|开鸿智谷助力开源<em>鸿蒙</em>城市技术沙龙·长沙站圆满落幕'},
{accountName:'开鸿智谷',articleTitle:'参会指南|长沙市新一代信息技术公共实训基地启用仪式暨第四届全国高校开源<em>鸿蒙</em>产教融合大会即将开幕！'},
{accountName:'开鸿智谷',articleTitle:'<em>鸿蒙</em>星光盛典|拓维信息及旗下开鸿智谷携手华为共攀中国科技高峰'},
{accountName:'开鸿智谷',articleTitle:'在一起，就可以！拓维信息&开鸿智谷与您携手相约《<em>鸿蒙</em>星光盛典》'},
{accountName:'开鸿智谷',articleTitle:'邀请函|长沙市新一代信息技术公共实训基地启用仪式暨第四届全国高校开源<em>鸿蒙</em>产教融合大会诚邀您的莅临！'},
{accountName:'开鸿智谷',articleTitle:'报名开启|"AI为先，芯动未来"开源<em>鸿蒙</em>城市技术沙龙·长沙站议程速览！'},
{accountName:'开鸿智谷',articleTitle:'一带一路<em>鸿蒙</em>端云智能应用开发大赛，开鸿智谷技术赋能高校学生斩获大奖！'},
{accountName:'开鸿智谷',articleTitle:'邀请函|长沙市新一代信息技术公共实训基地启用仪式暨第四届全国高校开源<em>鸿蒙</em>产教融合大会诚邀您的莅临！'},
{accountName:'开鸿智谷',articleTitle:'共推<em>鸿蒙</em>生态迈向新高度！拓维信息携开鸿智谷亮相开源<em>鸿蒙</em>行业论坛'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷受邀出席开源<em>鸿蒙</em>城市技术论坛（兰州站），共话“具身智能”新生态'},
{accountName:'开鸿智谷',articleTitle:'国产操作系统赋能，<em>鸿蒙</em>控制器打造船舶智能运维新范式'},
{accountName:'开鸿智谷',articleTitle:'2025开放原子开发者大会｜拓维信息携开鸿智谷成功承办开源<em>鸿蒙</em>技术分论坛'},
{accountName:'开鸿智谷',articleTitle:'明日直播|2025开放原子开发者大会开源<em>鸿蒙</em>技术分论坛即将启幕'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷高交会亮相：以“<em>鸿蒙</em>控制器”为核心，定义智慧医疗新未来'},
{accountName:'开鸿智谷',articleTitle:'2025开放原子开发者大会|拓维信息&开鸿智谷邀您共赴开源<em>鸿蒙</em>技术分论坛'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷参编行业<em>鸿蒙</em>蓝皮书正式发行，<em>鸿蒙</em>创新方案再获殊荣！'},
{accountName:'开鸿智谷',articleTitle:'拓维信息&开鸿智谷诚邀|关于参与《<em>鸿蒙</em>生态人才白皮书2025》问卷调查的通知'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷携手高校共绘“OS+AI”复合型人才培养新蓝图，构建开源<em>鸿蒙</em>教育新生态'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷“以赛促学、以赛选才”|1024程序员节暨开源<em>鸿蒙</em>构建大会圆满落幕！'},
{accountName:'开鸿智谷',articleTitle:'1024程序员节抢先集结：开源<em>鸿蒙</em>构建大会&AI编程技术沙龙同步开启'},
{accountName:'开鸿智谷',articleTitle:'拓维信息携开鸿智谷亮相第27届中国国际软件博览会，分享开源<em>鸿蒙</em>赋能行业数字化实践'},
{accountName:'开鸿智谷',articleTitle:'深化端侧AI与<em>鸿蒙</em>星闪技术布局，开鸿智谷助力谱写<em>鸿蒙</em>生态新篇章'},
{accountName:'开鸿智谷',articleTitle:'开源<em>鸿蒙</em>技术大会2025分论坛特辑|开鸿智谷多领域专家观点集锦速览'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷：做开源<em>鸿蒙</em>的“引领者”，在湘江之畔筑造万物智联新基石'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷开源<em>鸿蒙</em>合作伙伴大会暨高校人才培养研讨会在长沙成功举办！'},
{accountName:'开鸿智谷',articleTitle:'拓维信息携开鸿智谷重磅亮相开源<em>鸿蒙</em>技术大会2025|“在鸿OS”系列成果引领生态创新与实践'},
{accountName:'开鸿智谷',articleTitle:'拓维信息&开鸿智谷参会指南速递|开源<em>鸿蒙</em>技术大会2025就在明日！'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷史上最全生态展区即将开启！开源<em>鸿蒙</em>技术大会2025倒计时2天'},
{accountName:'开鸿智谷',articleTitle:'开源<em>鸿蒙</em>技术大会倒计时3天！开鸿智谷邀您共“湘”技术盛宴'},
{accountName:'开鸿智谷',articleTitle:'拓维信息携开鸿智谷亮相<em>鸿蒙</em>生态大会2025，共筑“新场景·新体验”，引领产业智联新未来'},
{accountName:'开鸿智谷',articleTitle:'开放融合，共赢<em>鸿蒙</em>新生态|拓维信息携开鸿智谷邀您共赴2025<em>鸿蒙</em>生态大会'},
{accountName:'开鸿智谷',articleTitle:'茅以升科学技术特等奖｜开鸿智谷联合公路院和华为基于开源<em>鸿蒙</em>打造的公路机电OS荣获表彰'},
{accountName:'开鸿智谷',articleTitle:'开鸿智谷助力开源<em>鸿蒙</em>城市技术沙龙暨AIModelSIG线下分享会圆满举办'},
{accountName:'开鸿智谷',articleTitle:'首场开源<em>鸿蒙</em>城市技术沙龙·深圳站明日启幕！'},
{accountName:'开鸿智谷',articleTitle:'正式签约|开鸿智谷与株洲科技职业学院共建开源<em>鸿蒙</em>技术学院'},
{accountName:'中软国际',articleTitle:'HPC2026丨中软国际展台直击：开源<em>鸿蒙</em>硬件矩阵展示，智能化企业操作系统EOS首次亮相'},
{accountName:'中软国际',articleTitle:'开源<em>鸿蒙</em>+AI，深开鸿推动龙岗首个智慧康养示范场景落地！'},
{accountName:'中软国际',articleTitle:'开源<em>鸿蒙</em>赋能智慧交通浦江S219路段实现安全管控新突破'},
{accountName:'中软国际',articleTitle:'全国首个开源<em>鸿蒙</em>智慧病区正式启用，深开鸿携手深圳龙岗中心医院打造智慧医疗新标杆'},
{accountName:'中软国际',articleTitle:'持续深耕<em>鸿蒙</em>生态，中软国际获GIIC<em>鸿蒙</em>生态推委会双奖肯定!'},
{accountName:'中软国际',articleTitle:'政企校三方协同，深开鸿向晋江市季延中学捐赠开源<em>鸿蒙</em>教育资源'},
{accountName:'中软国际',articleTitle:'开源<em>鸿蒙</em>生态共建成势，深开鸿主干代码贡献量破650万行'},
{accountName:'中软国际',articleTitle:'中软国际中国总部“未来之门”项目正式启动，打造AI原生创新高地与<em>鸿蒙</em>生态示范区'},
{accountName:'中软国际',articleTitle:'福田区2026年首期开源<em>鸿蒙</em>专题培训圆满举办，政企共筑产业创新高地'},
{accountName:'中软国际',articleTitle:'<em>鸿蒙</em>生态共赴星河|中软国际斩获2025年<em>鸿蒙</em>生态服务商大会多项大奖'},
{accountName:'中软国际',articleTitle:'深开鸿开源<em>鸿蒙</em>社区代码贡献量破650万行！'},
{accountName:'中软国际',articleTitle:'共建<em>鸿蒙</em>办公新生态|中软国际受邀出席2025<em>鸿蒙</em>办公产业峰会并获颁双奖'},
{accountName:'中软国际',articleTitle:'中软国际成功入选港交所科技100指数成份股，AI与<em>鸿蒙</em>核心能力获资本市场高度认可'},
{accountName:'中软国际',articleTitle:'<em>鸿蒙</em>星光盛典见证生态硕果！中软国际携深开鸿斩获开源<em>鸿蒙</em>双项荣誉！'},
{accountName:'中软国际',articleTitle:'开源<em>鸿蒙</em>赋能智慧交通：“冀鸿”打造隧道智能化新标杆'},
{accountName:'中软国际',articleTitle:'深开鸿助力打造深圳首个面向开源<em>鸿蒙</em>的开发者培训基地'},
{accountName:'中软国际',articleTitle:'深开鸿捐赠M-Robots项目，以开源<em>鸿蒙</em>统一底座推动机器人产业协同'},
{accountName:'中软国际',articleTitle:'中软国际携手深开鸿与奕斯伟计算达成战略合作，共建“开源<em>鸿蒙</em>+RISC-V”双开源数字基础设施新生态'},
{accountName:'中软国际',articleTitle:'深开鸿亮相CEIC消费电子创新大会，以“开源<em>鸿蒙</em>+AI”重构美好生活新体验'},
{accountName:'中软国际',articleTitle:'注入开源<em>鸿蒙</em>基因，深开鸿携手深天使点燃大湾区“金种子”创新引擎'},
{accountName:'中软国际',articleTitle:'中软国际亮相浙江开源<em>鸿蒙</em>生态发展大会，持续深化<em>鸿蒙</em>生态技术创新与产业协同'},
{accountName:'中软国际',articleTitle:'划重点！一图速览浦江开源<em>鸿蒙</em>生态大会金句'},
{accountName:'中软国际',articleTitle:'中软国际携手爱聚科技完成义乌<em>鸿蒙</em>生态合作签约，以“商贸+文旅”元服务模式构建数字服务新生态'},
{accountName:'中软国际',articleTitle:'开源<em>鸿蒙</em>生态成果集中亮相浦江，展示技术赋能与产业共进新图景'},
{accountName:'中软国际',articleTitle:'开源<em>鸿蒙</em>（金华）应用创新示范中心在浦江揭牌多方签约共建生态新格局'},
{accountName:'中软国际',articleTitle:'开源<em>鸿蒙</em>耕植浦江，提升县域人工智能发展竞争力'},
{accountName:'中软国际',articleTitle:'深开鸿亮相开源<em>鸿蒙</em>技术大会2025，以核心技术共建开源生态新格局'},
{accountName:'中软国际',articleTitle:'中软国际牵头揭榜智慧交通城市合伙人，西安市开源<em>鸿蒙</em>技术适配（认证）和产品开发中心隆重揭牌'},
{accountName:'中软国际',articleTitle:'工信部副部长一行西安调研中软国际聚焦开源<em>鸿蒙</em>生态建设与国产操作系统高质量发展'},
{accountName:'中软国际',articleTitle:'8家企业强强联合|西安打响智慧交通“<em>鸿蒙</em>第一枪”'},
{accountName:'中软国际',articleTitle:'以<em>鸿蒙</em>技术重构全场景阅读，中软国际全面推进“应用+智慧场景”生态建设'},
{accountName:'中软国际',articleTitle:'中软国际携手深开鸿与中软国际教育，携多款<em>鸿蒙</em>生态产品亮相2025<em>鸿蒙</em>生态大会'},
{accountName:'中软国际',articleTitle:'基于开源<em>鸿蒙</em>打造的公路机电操作系统获“茅以升科学技术特等奖”！'},
{accountName:'中软国际',articleTitle:'中软国际携手爱聚科技，与山东文旅完成省级<em>鸿蒙</em>生态合作签约'},
{accountName:'中软国际',articleTitle:'全国首个开源<em>鸿蒙</em>机器人操作系统M-RobotsOS正式开源'},
{accountName:'中软国际',articleTitle:'深开鸿王成录：以七大使能厚植生态，推进开源<em>鸿蒙</em>全面落地'},
{accountName:'中软国际',articleTitle:'中软国际卢弋：根植城市物联子网沃土，繁荣开源<em>鸿蒙</em>智能终端行业品类生态'},
{accountName:'中软国际',articleTitle:'中软国际携手爱聚科技，与甘肃省武威市文体广电和旅游局完成「乐游武威」<em>鸿蒙</em>生态合作签约'},
{accountName:'中软国际',articleTitle:'南京论坛丨AI+<em>鸿蒙</em>，共筑全场景AI应用新引擎'},
{accountName:'中软国际',articleTitle:'全国首个985高校开源<em>鸿蒙</em>微专业落地！深开鸿与华中科技大学联合培养智能信息系统人才'},
{accountName:'中软国际',articleTitle:'中软国际携手爱聚科技，与齐齐哈尔文旅局完成「乐游鹤城」<em>鸿蒙</em>生态合作签约'},
{accountName:'中软国际',articleTitle:'开鸿开发板深度体验：从开源<em>鸿蒙</em>开发到AI场景实践'},
{accountName:'中软国际',articleTitle:'中软国际助力浙数文旅打造<em>鸿蒙</em>生态省域级文旅平台“游浙里”：数字共生，智绘诗画浙江'},
{accountName:'中软国际',articleTitle:'HDC2025|中软国际在<em>鸿蒙</em>电脑应用生态的实践与展望：持续推动工具与生态的深度融合'},
{accountName:'中软国际',articleTitle:'超530万行！深开鸿的开源<em>鸿蒙</em>社区代码贡献量再创新高度！'},
{accountName:'中软国际',articleTitle:'HDC2025|中软国际文旅SaaS平台成功落地“乐游威海”：以“<em>鸿蒙</em>生态+AI”助推文旅产业高质量发展'},
{accountName:'中软国际',articleTitle:'中软国际、深开鸿携「AI+<em>鸿蒙</em>」闪耀华为开发者大会2025'},
{accountName:'中软国际',articleTitle:'以数字政府建设牵引数字经济发展，中软国际开源<em>鸿蒙</em>技术赋能西安智慧交通'},
{accountName:'中软国际',articleTitle:'鸿云虚拟机安装指南：手把手教你玩转<em>鸿蒙</em>电脑双系统！'},
{accountName:'鸿鹄万联',articleTitle:'前60名免费学！“<em>鸿蒙</em>生态・星光学堂”深圳南山专场，HarmonyOS应用开发者培训正式报名'},
{accountName:'鸿鹄万联',articleTitle:'<em>鸿蒙</em>筑基，新春护航：鸿湖万联筑牢智慧交通安全防线'},
{accountName:'鸿鹄万联',articleTitle:'软通动力子公司鸿湖万联深度融合开源<em>鸿蒙</em>创新场景，助力深港创新产业协同发展'},
{accountName:'鸿鹄万联',articleTitle:'软通动力携鸿湖万联、软通教育连获<em>鸿蒙</em>生态“突出贡献单位”“先锋伙伴”等七项荣誉'},
{accountName:'鸿鹄万联',articleTitle:'“<em>鸿蒙</em>应用培训讲师认证”正式启动报名！'},
{accountName:'鸿鹄万联',articleTitle:'“<em>鸿蒙</em>设备开发讲师认证”报名正式开启！'},
{accountName:'鸿鹄万联',articleTitle:'前60名免费学！“<em>鸿蒙</em>生态・星光学堂”落地深圳南山，OpenHarmony设备开发者培训报名开启'},
{accountName:'鸿鹄万联',articleTitle:'软通动力子公司鸿湖万联聚力<em>鸿蒙</em>生态人才大会，联合发布<em>鸿蒙</em>人才白皮书与讲师认证标准'},
{accountName:'鸿鹄万联',articleTitle:'“在一起”软通动力与<em>鸿蒙</em>共聚星光盛典，共启发展新篇'},
{accountName:'鸿鹄万联',articleTitle:'全栈信创标杆！软通华方开源<em>鸿蒙</em>智慧屏的技术革新与商业赋能'},
{accountName:'鸿鹄万联',articleTitle:'开源+AI：“软通天鸿操作系统6”正式发布，以全栈智能助推开源<em>鸿蒙</em>全域商用'},
{accountName:'鸿鹄万联',articleTitle:'鸿湖万联邀您一图纵览I软通动力首款全自研开源<em>鸿蒙</em>智慧屏'},
{accountName:'鸿鹄万联',articleTitle:'首发！软通天鸿OS6与开源<em>鸿蒙</em>智慧屏，自主创新产品加速开源<em>鸿蒙</em>商业生态构建'},
{accountName:'鸿鹄万联',articleTitle:'<em>鸿蒙</em>生态·星光学堂OpenHarmony设备开发深圳市龙华区专场：技术赋能升级，企业开发者共绘<em>鸿蒙</em>生态蓝图'},
{accountName:'鸿鹄万联',articleTitle:'【<em>鸿蒙</em>福利】价值4999元HarmonyOS开发培训，12.19深圳湾科技生态园！'},
{accountName:'鸿鹄万联',articleTitle:'首款开源<em>鸿蒙</em>AI摄像头荣膺“年度价值商用案例”，软通动力子公司鸿湖万联构筑数字世界感知基础'},
{accountName:'鸿鹄万联',articleTitle:'软通动力子公司鸿湖万联斩获开源<em>鸿蒙</em>“代码贡献”和“商业价值”多项荣誉'},
{accountName:'鸿鹄万联',articleTitle:'软通动力子公司鸿湖万联亮相高交会以开源<em>鸿蒙</em>创新成果引领产业升级'},
{accountName:'鸿鹄万联',articleTitle:'鸿湖万联诚邀丨关于参与《<em>鸿蒙</em>生态人才白皮书2025》问卷调查的通知'},
{accountName:'鸿鹄万联',articleTitle:'【马上报名】2025年深圳开源<em>鸿蒙</em>/RISC-V创新应用大赛正式启动'},
{accountName:'鸿鹄万联',articleTitle:'软通动力亮相<em>鸿蒙</em>生态大会2025全方位助推<em>鸿蒙</em>生态建设'},
{accountName:'鸿鹄万联',articleTitle:'开源<em>鸿蒙</em>创新成果齐亮相|软通动力子公司鸿湖万联助阵华为开发者大会2025成功举办'},
{accountName:'鸿鹄万联',articleTitle:'开源<em>鸿蒙</em>5.1重磅发布！软通动力携子公司鸿湖万联助力国产操作系统创新升级'},
{accountName:'鸿鹄万联',articleTitle:'鸿湖万联诚邀莅临丨开源<em>鸿蒙</em>开发者大会2025'},
{accountName:'鸿鹄万联',articleTitle:'持续突破！软通动力以开源<em>鸿蒙</em>之力筑牢数字经济底座'},
{accountName:'鸿鹄万联',articleTitle:'全国开源<em>鸿蒙</em>智能终端与物联行业产教融合共同体邀请函'},
{accountName:'鸿鹄万联',articleTitle:'活动预告|全国开源<em>鸿蒙</em>智能终端与物联行业产教融合共同体师资培训'},
{accountName:'鸿鹄万联',articleTitle:'开源<em>鸿蒙</em>+AI：软通动力子公司鸿湖万联闪耀华为中国合作伙伴大会2025'},
{accountName:'鸿鹄万联',articleTitle:'<em>鸿蒙</em>生态再发力！软通动力携子公司鸿湖万联出席2025武汉<em>鸿蒙</em>产业发展交流会'},
{accountName:'鸿鹄万联',articleTitle:'开工大吉|开源<em>鸿蒙</em>蓬勃启新程鸿湖万联聚力创新篇'},
{accountName:'鸿鹄万联',articleTitle:'产业合作再升级！软通动力携手微展世发布WeOS开源<em>鸿蒙</em>工业操作系统'},
{accountName:'鸿鹄万联',articleTitle:'共荣开源生态！软通动力子公司鸿湖万联荣获“2024年度开源<em>鸿蒙</em>社区卓越单位”'},
{accountName:'鸿鹄万联',articleTitle:'软通动力携鸿湖万联与微展世签署战略合作协议，以开源<em>鸿蒙</em>赋能工业创新升级'},
{accountName:'鸿鹄万联',articleTitle:'‌软通动力子公司鸿湖万联携手南方科技大学共筑开源<em>鸿蒙</em>人才培养新高地'},
{accountName:'鸿鹄万联',articleTitle:'<em>鸿蒙</em>产业学院正式揭牌！软通动力与深信息签署校企合作框架协议'},
{accountName:'鸿鹄万联',articleTitle:'深化开源<em>鸿蒙</em>人才培养实践软通动力子公司鸿湖万联参与粤港澳三地技能人才资源对接日'},
{accountName:'鸿鹄万联',articleTitle:'软通动力携子公司鸿湖万联、软通教育助阵首届<em>鸿蒙</em>生态大会成功举办'},
{accountName:'鸿鹄万联',articleTitle:'原⽣<em>鸿蒙</em>发布！软通动力子公司鸿湖万联智能成果获媒体报道关注'},
{accountName:'鸿鹄万联',articleTitle:'软通动力子公司鸿湖万联助阵<em>鸿蒙</em>1024程序员节成功举办'},
{accountName:'鸿鹄万联',articleTitle:'软通动力子公司鸿湖万联重磅发布SwanLinkOS5，擘画开源<em>鸿蒙</em>AIPC新篇章'},
{accountName:'鸿鹄万联',articleTitle:'共赴<em>鸿蒙</em>星辰山海|软通动力子公司鸿湖万联参与揭幕中部首个<em>鸿蒙</em>生态创新中心'},
{accountName:'鸿鹄万联',articleTitle:'SwanLinkOS首批实现与HarmonyOSNEXT互联互通，软通动力子公司鸿湖万联助力<em>鸿蒙</em>生态统一互联'},
{accountName:'鸿鹄万联',articleTitle:'雄安发布|鸿湖万联持续助力雄安城市<em>鸿蒙</em>生态建设'},
{accountName:'鸿鹄万联',articleTitle:'人才储备再升级！软通动力子公司鸿湖万联多名讲师荣获首批“<em>鸿蒙</em>原生应用开发培训讲师”认证'},
{accountName:'鸿鹄万联',articleTitle:'<em>鸿蒙</em>生态共筑互联|软通动力携子公司鸿湖万联共同揭幕<em>鸿蒙</em>生态创新中心'},
{accountName:'鸿鹄万联',articleTitle:'共谱开源新篇章软通动力子公司鸿湖万联与<em>鸿蒙</em>生态服务公司签署战略合作协议'},
{accountName:'鸿鹄万联',articleTitle:'开源启智<em>鸿蒙</em>领跑|软通动力子公司鸿湖万联亮相第二届OpenHarmony技术大会'},
{accountName:'鸿鹄万联',articleTitle:'借“<em>鸿蒙</em>”东风软通动力子公司鸿湖万联扬帆2023深圳·中国1024程序员节'},
{accountName:'鸿鹄万联',articleTitle:'开源<em>鸿蒙</em>生态、芯片适配先行|鸿湖万联亮相第四届“1024程序员节”'},
{accountName:'鸿鹄万联',articleTitle:'创新为先<em>鸿蒙</em>引领|软通动力再度签约雄安亮相2023软件和信息技术服务业创新发展论坛'},
{accountName:'诚迈科技',articleTitle:'诚迈科技持续深耕开源<em>鸿蒙</em>生态，斩获“先锋单位”及“示范案例”荣誉'},
{accountName:'诚迈科技',articleTitle:'2025开放原子开发者大会丨诚迈科技鸿志操作系统加速开源<em>鸿蒙</em>产业落地'},
{accountName:'诚迈科技',articleTitle:'诚迈科技携鸿志操作系统亮相开源<em>鸿蒙</em>技术大会，共筑产业数字未来'},
{accountName:'诚迈科技',articleTitle:'诚迈科技亮相<em>鸿蒙</em>生态大会，共拓万物智联新场景'},
{accountName:'诚迈科技',articleTitle:'诚迈科技发布基于鸿志桌面操作系统和龙芯3A6000的开源<em>鸿蒙</em>电脑'},
{accountName:'诚迈科技',articleTitle:'诚迈科技携<em>鸿蒙</em>生态成果精彩亮相华为开发者大会2025'},
{accountName:'诚迈科技',articleTitle:'诚迈科技携HongZOS亮相开源<em>鸿蒙</em>开发者大会，加速生态繁荣与产业跃迁'},
{accountName:'诚迈科技',articleTitle:'警用<em>鸿蒙</em>操作系统正式亮相，诚迈科技携智能警务终端参展警博会'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态大势已成，诚迈科技<em>鸿蒙</em>实验室助力院校人才培养'},
{accountName:'诚迈科技',articleTitle:'诚迈科技旗下智达诚远推出基于开源<em>鸿蒙</em>的国产汽车座舱系统——鸿志汽车座舱系统'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技亮相华为中国合作伙伴大会，展示矿鸿生态成果'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技HongZOS接入DeepSeek，助力企业加速AIoT应用'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技亮相2024开放原子开发者大会，共同发布开源<em>鸿蒙</em>5.0'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技以开源<em>鸿蒙</em>为底座，赋能新型工业化'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技升级为开源<em>鸿蒙</em>项目群A类捐赠人'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技荣获“开源<em>鸿蒙</em>人才认证授权培训伙伴（优选级）”授牌'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技与粤港澳大湾区国家技术创新中心签署嵌入式数据库合作备忘录'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技加入开源<em>鸿蒙</em>产教融合中心，助力甘肃打造数字产业人才高地'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技加入全球智慧物联网联盟，推动<em>鸿蒙</em>万物智联生态走向世界'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技凝聚创新共识，书写提质增效的温州工业答卷'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技亮相中国国际软博会，共话开源<em>鸿蒙</em>赋能产业变革'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨诚迈科技出席<em>鸿蒙</em>1024程序员节，助力武汉、成都建设<em>鸿蒙</em>生态场景'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态丨原生<em>鸿蒙</em>操作系统正式发布，诚迈科技与华为一起共建<em>鸿蒙</em>新世界'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>生态｜诚迈科技联合龙芯中科发布基于龙架构的开源<em>鸿蒙</em>方案'},
{accountName:'诚迈科技',articleTitle:'第三届OpenHarmony技术大会丨诚迈科技深耕<em>鸿蒙</em>生态，共赢数智时代'},
{accountName:'诚迈科技',articleTitle:'诚迈科技获“鸿星闪耀先锋伙伴”授牌，引领“<em>鸿蒙</em>+星闪”融合创新'},
{accountName:'诚迈科技',articleTitle:'OpenHarmony社区会议丨诚迈科技基于开源<em>鸿蒙</em>底座，助推武汉打造全国开源开放创新高地'},
{accountName:'诚迈科技',articleTitle:'诚迈科技与中国移动智慧家庭运营中心达成合作，以开源<em>鸿蒙</em>为底座智启AI家'},
{accountName:'诚迈科技',articleTitle:'诚迈科技受邀见证<em>鸿蒙</em>生态（武汉）创新中心揭牌，助力开源<em>鸿蒙</em>加快落地华中区域'},
{accountName:'诚迈科技',articleTitle:'深耕<em>鸿蒙</em>沃土，催生“产业新绿”丨诚迈科技HongZOS精彩亮相华为开发者大会2024'},
{accountName:'诚迈科技',articleTitle:'西部首个<em>鸿蒙</em>生态创新中心揭幕，诚迈科技携手共建！'},
{accountName:'诚迈科技',articleTitle:'诚迈科技鸿志教育实训箱落地中国矿业大学徐海学院，共育<em>鸿蒙</em>人才！'},
{accountName:'诚迈科技',articleTitle:'40+兼容性证书，诚迈科技以实力为开源<em>鸿蒙</em>生态繁荣助力'},
{accountName:'诚迈科技',articleTitle:'诚迈科技走进华为，共探<em>鸿蒙</em>生态未来新篇章'},
{accountName:'诚迈科技',articleTitle:'共筑互联丨<em>鸿蒙</em>生态创新中心正式启用，诚迈科技携手共揭新篇章'},
{accountName:'诚迈科技',articleTitle:'诚迈科技获得华为开发者联盟生态市场服务商认证，共筑<em>鸿蒙</em>世界'},
{accountName:'诚迈科技',articleTitle:'星河璀璨千帆启航丨诚迈科技应邀参加<em>鸿蒙</em>生态千帆启航仪式'},
{accountName:'诚迈科技',articleTitle:'诚迈科技与<em>鸿蒙</em>生态服务公司签署合作协议，共谋<em>鸿蒙</em>生态创新发展'},
{accountName:'诚迈科技',articleTitle:'诚迈科技策「码」开源<em>鸿蒙</em>，构筑工业数字底座'},
{accountName:'诚迈科技',articleTitle:'以业兴才，诚迈科技探索<em>鸿蒙</em>生态人才培养新路径'},
{accountName:'诚迈科技',articleTitle:'诚迈科技释放开源<em>鸿蒙</em>创新力，着力构建万物智联之基'},
{accountName:'诚迈科技',articleTitle:'诚迈科技深耕开源<em>鸿蒙</em>，以HongZOS为新型工业化赋智聚能'},
{accountName:'诚迈科技',articleTitle:'OpenHarmony技术大会丨诚迈科技共筑开源<em>鸿蒙</em>生态，引领智联未来'},
{accountName:'诚迈科技',articleTitle:'诚迈科技出席江苏省高校信创与安全生态论坛，共话开源<em>鸿蒙</em>人才的联合培养'},
{accountName:'诚迈科技',articleTitle:'诚迈科技创新赋能雄安新区，共建城市<em>鸿蒙</em>生态'},
{accountName:'诚迈科技',articleTitle:'赋能工业数字化，诚迈科技基于开源<em>鸿蒙</em>的鸿制系列三防设备通过认证'},
{accountName:'诚迈科技',articleTitle:'诚迈科技成为华为终端云服务“元服务服务商”，共建<em>鸿蒙</em>生态'},
{accountName:'诚迈科技',articleTitle:'诚迈科技助力立达信智能照明接入<em>鸿蒙</em>生态，点亮美好生活'},
{accountName:'诚迈科技',articleTitle:'诚迈科技助力雄安新区<em>鸿蒙</em>产业创新发展，打造城市<em>鸿蒙</em>之城'},
{accountName:'诚迈科技',articleTitle:'<em>鸿蒙</em>智联丨诚迈科技助力霍尼韦尔空气净化器开启智能新篇章'},
{accountName:'佳都科技',articleTitle:'全国首个省级开源<em>鸿蒙</em>适配中心落地黄埔佳都科技获颁全省首张开源<em>鸿蒙</em>生态产品适配认证证书'},
{accountName:'佳都科技',articleTitle:'未来坐地铁有多酷？佳都科技助力全国首个<em>鸿蒙</em>智慧车站落地深圳'},
{accountName:'佳都科技',articleTitle:'广州新闻联播|紧抓机遇打造“<em>鸿蒙</em>之城”为广州产业发展焕“芯”升级'},
{accountName:'佳都科技',articleTitle:'广州两会｜市政协委员、佳都科技高级副总裁刘佳献良策：聚焦<em>鸿蒙</em>生态、数据要素与具身智能'},
{accountName:'佳都科技',articleTitle:'新一代国产嵌入式工控机，基于星闪与<em>鸿蒙</em>打造极致流畅通行体验'},
{accountName:'佳都科技',articleTitle:'就在明天！聚焦“交通佳鸿”，与佳都科技共赴开源<em>鸿蒙</em>行业论坛'},
{accountName:'佳都科技',articleTitle:'2025中国智能交通年会|佳都科技：AI赋能交通新动能，<em>鸿蒙</em>筑底生态新格局'},
{accountName:'佳都科技',articleTitle:'佳都科技亮相第二届CCF数字交通大会，大模型+开源<em>鸿蒙</em>助力智慧交通创新发展'},
{accountName:'佳都科技',articleTitle:'佳都科技中标深圳地铁NOCC二期“城轨云”项目<em>鸿蒙</em>物联+AI助力打造智慧城轨“超级大脑”'},
{accountName:'佳都科技',articleTitle:'佳都科技与温州签署战略合作框架协议，共筑开源<em>鸿蒙</em>产业生态新篇章'},
{accountName:'佳都科技',articleTitle:'精彩预告|开源<em>鸿蒙</em>技术大会2025即将在长沙启幕，佳都科技邀您共襄硬核技术盛宴'},
{accountName:'佳都科技',articleTitle:'AI+开源<em>鸿蒙</em>：佳都科技助力西安打造“智慧交通<em>鸿蒙</em>生态标杆”'},
{accountName:'佳都科技',articleTitle:'佳都科技中标全国首个开源<em>鸿蒙</em>国创城轨整体解决方案项目，智慧交通国产化落地提速'},
{accountName:'佳都科技',articleTitle:'佳都科技亮相2025<em>鸿蒙</em>生态大会，助推交通行业全面拥抱开源<em>鸿蒙</em>'},
{accountName:'佳都科技',articleTitle:'就在明天！佳都诚邀您莅临2025<em>鸿蒙</em>生态大会，共创智慧交通未来'},
{accountName:'佳都科技',articleTitle:'倒计时2天|2025<em>鸿蒙</em>生态大会即将开幕，邀您共绘交通<em>鸿蒙</em>新蓝图'},
{accountName:'佳都科技',articleTitle:'交通佳鸿|终端互信互联，乘客无感通行！<em>鸿蒙</em>和星闪技术赋能轨交AFC系统'},
{accountName:'佳都科技',articleTitle:'开源<em>鸿蒙</em>开发者大会2025成功举办，佳都科技共筑万物智联新生态'},
{accountName:'佳都科技',articleTitle:'<em>鸿蒙</em>“交通版”来了！佳都科技重磅发布城市群立体交通首个<em>鸿蒙</em>操作系统'},
{accountName:'佳都科技',articleTitle:'倒计时3天｜开源<em>鸿蒙</em>面向交通行业的“交通佳鸿”即将正式发布！'},
{accountName:'中控信息',articleTitle:'<em>鸿蒙</em>筑基，AI赋能：中控信息携手华为，共建城市智能运行新生态'},
{accountName:'奥思维',articleTitle:'奥思维出席开源<em>鸿蒙</em>产品供需对接会共筑生态新图景'},
{accountName:'奥思维',articleTitle:'聚焦AI与开源融合，奥思维携开源<em>鸿蒙</em>智能座舱闪耀2025开放原子开发者大会'},
{accountName:'奥思维',articleTitle:'奥思维亮相开源<em>鸿蒙</em>技术大会2025'},
{accountName:'奥思维',articleTitle:'从技术分享到产品落地：OSWare亮相2025开放原子开源生态大会，深耕开源<em>鸿蒙</em>生态'},
{accountName:'奥思维',articleTitle:'OSWare奥思维携<em>鸿蒙</em>生态成果亮相HDC2025'},
{accountName:'奥思维',articleTitle:'OSWare携KANZI开源<em>鸿蒙</em>版闪耀亮相开源<em>鸿蒙</em>开发者大会2025'},
{accountName:'奥思维',articleTitle:'苏州首批工业<em>鸿蒙</em>项目签约，OSWare奥思维携手多家企业共推产业升级'},
{accountName:'奥思维',articleTitle:'奥思维出席<em>鸿蒙</em>生态（武汉）创新中心揭牌仪式'},
{accountName:'国开鸿',articleTitle:'国开鸿发布<em>鸿蒙</em>智能边端AI主机，以端侧算力中枢赋能千行百业智能化升级'},
{accountName:'国开鸿',articleTitle:'国开鸿2026招聘｜揽数智精英，赴<em>鸿蒙</em>新程'},
{accountName:'国开鸿',articleTitle:'<em>鸿蒙</em>政务场景亮相国产操作系统和芯片高质量发展推进会'},
{accountName:'国开鸿',articleTitle:'国开鸿赋能深圳首个<em>鸿蒙</em>政务服务中心在罗湖落地，以技术创新引领智慧政务新变革'},
{accountName:'国开鸿',articleTitle:'深圳首个<em>鸿蒙</em>政务服务中心在罗湖启用'},
{accountName:'国开鸿',articleTitle:'<em>鸿蒙</em>办公产业峰会登陆武汉，国开鸿继PDBox之后，发布PDDock万能底座打通外设互联“最后一公里”'},
{accountName:'国开鸿',articleTitle:'国开鸿亮相开源<em>鸿蒙</em>技术大会 2025，共建共享万物智联新未来'},
{accountName:'国开鸿',articleTitle:'强强联合！慧博云通与国开鸿达成战略合作，共绘开源<em>鸿蒙</em>生态新蓝图'},
{accountName:'国开鸿',articleTitle:'国开鸿亮相<em>鸿蒙</em>生态大会2025，与千行百业共绘万物智联新图景'},
{accountName:'国开鸿',articleTitle:'国开鸿邀您参加2025<em>鸿蒙</em>生态大会'},
{accountName:'国开鸿',articleTitle:'<em>鸿蒙</em>生态迎来外设兼容革命！国开鸿PDBox外设万能盒在HDC2025大放异彩'},
{accountName:'国开鸿',articleTitle:'OHDC.2025|国开鸿作为开源<em>鸿蒙</em>项目群B类捐赠人受邀出席'},
{accountName:'国开鸿',articleTitle:'<em>鸿蒙</em>电脑生态再升级！国开鸿存量外设“神秘方案”即将解锁'},
{accountName:'鼎桥',articleTitle:'<em>鸿蒙</em>启航·共筑成都产业新生态，鼎桥技术亮相华为软件（成都）生态大会'},
{accountName:'鼎桥',articleTitle:'<em>鸿蒙</em>智能手表助力行业创新|鼎桥行业穿戴新品上市'},
{accountName:'鼎桥',articleTitle:'智慧跃迁！鼎桥警用<em>鸿蒙</em>AI联袂贵州方阵，解锁政务查询新范式'},
{accountName:'鼎桥',articleTitle:'第12届警博会｜鼎桥通信邀您共赴警用<em>鸿蒙</em>装备技术论坛'},
{accountName:'鼎桥',articleTitle:'PowerHarmony+电力<em>鸿蒙</em>|鼎桥亮相南网<em>鸿蒙</em>发布会'},
{accountName:'中科略鸿',articleTitle:'二十四节气|春分玄鸟归日，<em>鸿蒙</em>启程'},
{accountName:'中科略鸿',articleTitle:'初八开工│聚势启新程，<em>鸿蒙</em>日日新'},
{accountName:'中科略鸿',articleTitle:'除夕围炉话<em>鸿蒙</em>，新程笃行趁春风'},
{accountName:'中科略鸿',articleTitle:'在一起，就可以！<em>鸿蒙</em>星光盛典圆满收官，中科鸿略与你共同期待创新未来'},
{accountName:'中科略鸿',articleTitle:'2025<em>鸿蒙</em>生态城市推介会（北京站）│中科鸿略与多家生态伙伴共同领航华北<em>鸿蒙</em>生态发展新高地'},
{accountName:'中科略鸿',articleTitle:'倒计时1天│2025<em>鸿蒙</em>生态城市推介会（北京站）明日即将启幕，敬请期待！'},
{accountName:'中科略鸿',articleTitle:'倒计时2天│2025<em>鸿蒙</em>生态城市推介会（北京站）—赴一场“无界<em>鸿蒙</em>”生态之约'},
{accountName:'中科略鸿',articleTitle:'“万亿生态，亿元激励”2025<em>鸿蒙</em>生态城市推介会（北京站）助力企业抢占万物智联先机'},
{accountName:'中科略鸿',articleTitle:'2025<em>鸿蒙</em>生态城市推介会-北京站：京华聚势，<em>鸿蒙</em>无界'},
{accountName:'中科略鸿',articleTitle:'4天两城，2场展出！中科鸿略携开源<em>鸿蒙</em>政务方案双城闪耀，开启协同办公新纪元'},
{accountName:'中科略鸿',articleTitle:'第二十七届高交会精彩启幕│中科鸿略携开源<em>鸿蒙</em>智慧全场景解决方案亮相“国之重器”展区'},
{accountName:'中科略鸿',articleTitle:'2025中国移动全球合作伙伴大会圆满落幕，政务<em>鸿蒙</em>亮点回顾'},
{accountName:'中科略鸿',articleTitle:'共建共享开源<em>鸿蒙</em>新世界｜中科鸿略亮相开源<em>鸿蒙</em>技术大会2025'},
{accountName:'中科略鸿',articleTitle:'第十届华为全联接大会举办在即｜中科鸿略推出基于开源<em>鸿蒙</em>的DLNA投屏方案'},
{accountName:'中科略鸿',articleTitle:'共绘<em>鸿蒙</em>新篇章｜中科鸿略亮相2025<em>鸿蒙</em>生态大会'},
{accountName:'中科略鸿',articleTitle:'中科鸿略发布开源<em>鸿蒙</em>支持WAPI网络标准解决方案'},
{accountName:'中科略鸿',articleTitle:'中科鸿略发布开源<em>鸿蒙</em>北斗智能终端解决方案：智启通信新纪元'},
{accountName:'中科略鸿',articleTitle:'中科鸿略推出开源<em>鸿蒙</em>NFC解决方案：开启智慧近场通信新模式'},
{accountName:'中科略鸿',articleTitle:'中科鸿略发布开源<em>鸿蒙</em>MTP（媒体传输协议）行业解决方案'},
{accountName:'中科略鸿',articleTitle:'中科鸿略受邀参加开源<em>鸿蒙</em>开发者大会，携手共创万物智联世界的美好未来！'},
{accountName:'中科略鸿',articleTitle:'第十二届中国国际警用装备博览会│中科鸿略携近百款开源<em>鸿蒙</em>警用设备亮相'},
{accountName:'中科略鸿',articleTitle:'开源聚力<em>鸿蒙</em>启新|大年初一，中科鸿略恭祝大家新年快乐'},
{accountName:'中科略鸿',articleTitle:'中科鸿略发布基于开源<em>鸿蒙</em>5.0的商业发行版'},
{accountName:'中科略鸿',articleTitle:'2024全球数字科技生态大会│中科鸿略立足<em>鸿蒙</em>生态以核心技术创新为数字经济的发展贡献力量'},
{accountName:'中科略鸿',articleTitle:'智慧领航，共绘<em>鸿蒙</em>未来-中科鸿略受邀出席首届<em>鸿蒙</em>生态大会'},
{accountName:'中科略鸿',articleTitle:'中科鸿略携开源<em>鸿蒙</em>教育解决方案亮相2024全球智慧教育大会'},
{accountName:'中科略鸿',articleTitle:'<em>鸿蒙</em>生态（武汉）创新中心揭牌，中科鸿略携手共建，共创新篇章'},
{accountName:'智开鸿',articleTitle:'在深圳，有一种更安心的养老，叫「住进<em>鸿蒙</em>智慧家」'},
{accountName:'智开鸿',articleTitle:'政企同心筑养老新篇！智开鸿获福保街道调研肯定，<em>鸿蒙</em>生态赋能“一老一小”服务升级'},
{accountName:'智开鸿',articleTitle:'岁末暖信｜智开鸿与开源<em>鸿蒙</em>共赴下一场开源之约'},
{accountName:'智开鸿',articleTitle:'赋能养老产业，共创智慧未来！全场景<em>鸿蒙</em>养老解决方案在罗湖发布'},
{accountName:'智开鸿',articleTitle:'赋能养老产业，共创智慧未来——全场景<em>鸿蒙</em>养老解决方案'},
{accountName:'智开鸿',articleTitle:'开源<em>鸿蒙</em>大会长沙落幕！智开鸿获授牌，领跑<em>鸿蒙</em>适老化场景落地'},
{accountName:'智开鸿',articleTitle:'智开鸿亮相<em>鸿蒙</em>智选秋季发布会解锁智能护理新场景'},
{accountName:'智开鸿',articleTitle:'拥抱<em>鸿蒙</em>，共建未来——HDD深大交流会成功举办'},
{accountName:'智开鸿',articleTitle:'智开鸿受邀华为峰会，分享<em>鸿蒙</em>AI赋能银发经济新实践'},
{accountName:'智开鸿',articleTitle:'智开鸿受邀华为峰会，分享<em>鸿蒙</em>AI赋能银发经济新实践',publishTime:'45867.875'},

];
const searchKey = ref('');
const selectedAccount = ref('');
const currentPage = ref(1);
const pageSize = 15;

// 所有账号列表（去重）
const accountList = computed(() => {
  const set = new Set(originalTableData.map(r => r.accountName));
  return [...set];
});

// 搜索 + 账号过滤
const filterTableData = computed(() => {
  let data = originalTableData;
  if (selectedAccount.value) {
    data = data.filter(r => r.accountName === selectedAccount.value);
  }
  if (searchKey.value.trim()) {
    const key = searchKey.value.toLowerCase().trim();
    data = data.filter(r =>
      r.accountName.toLowerCase().includes(key) ||
      r.articleTitle.toLowerCase().includes(key)
    );
  }
  return data;
});

// 切换筛选条件时重置到第1页
watch([filterTableData], () => { currentPage.value = 1; });

const totalPages = computed(() => Math.ceil(filterTableData.value.length / pageSize));

const pagedData = computed(() => {
  const start = (currentPage.value - 1) * pageSize;
  return filterTableData.value.slice(start, start + pageSize);
});

// 分页按钮列表（含省略号）
const displayedPages = computed(() => {
  const total = totalPages.value;
  const cur = currentPage.value;
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [];
  pages.push(1);
  if (cur > 3) pages.push('...');
  for (let i = Math.max(2, cur - 1); i <= Math.min(total - 1, cur + 1); i++) pages.push(i);
  if (cur < total - 2) pages.push('...');
  pages.push(total);
  return pages;
});
</script>

<style scoped>
/* ===== 页面整体 ===== */
.page-wrapper {
  padding: 20px 24px;
  background: #ffffff;
  min-height: 100%;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  box-sizing: border-box;
}

/* ===== 页面标题 ===== */
.page-header { margin-bottom: 20px; }
.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a2e;
  margin: 0;
  padding-left: 12px;
  border-left: 4px solid #1677ff;
}

/* ===== 统计卡片行 ===== */
.stat-row {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.stat-card {
  flex: 1;
  min-width: 160px;
  background: #ffffff;
  border-radius: 10px;
  padding: 18px 20px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.stat-label {
  font-size: 13px;
  color: #8c8c8c;
}
.stat-value {
  font-size: 26px;
  font-weight: 700;
  color: #262626;
  line-height: 1.2;
}
.stat-value.highlight-blue  { color: #1677ff; }
.stat-value.highlight-green { color: #52c41a; }
.stat-value.highlight-orange{ color: #fa8c16; }

/* ===== 主内容卡片 ===== */
.content-card {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  overflow: hidden;
}
.card-header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #f0f0f0;
}
.card-title-text {
  font-size: 15px;
  font-weight: 600;
  color: #262626;
}

/* ===== 工具栏 ===== */
.toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #f5f5f5;
}

/* 账号 Tab */
.account-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.tab-btn {
  padding: 5px 14px;
  border-radius: 20px;
  border: 1px solid #d9d9d9;
  background: #ffffff;
  color: #595959;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}
.tab-btn:hover {
  border-color: #1677ff;
  color: #1677ff;
}
.tab-btn.active {
  background: #1677ff;
  border-color: #1677ff;
  color: #ffffff;
  font-weight: 500;
}

/* 搜索框 */
.search-box {
  display: flex;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 5px 12px;
  background: #fafafa;
  min-width: 220px;
  gap: 6px;
  transition: border-color 0.2s;
}
.search-box:focus-within {
  border-color: #1677ff;
  background: #fff;
}
.search-icon { font-size: 13px; color: #bfbfbf; }
.search-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: #262626;
  width: 180px;
}

/* ===== 表格 ===== */
.table-wrap {
  width: 100%;
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.data-table thead tr {
  background: #fafafa;
}
.data-table th {
  padding: 11px 16px;
  font-weight: 600;
  color: #595959;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
  white-space: nowrap;
}
.data-table td {
  padding: 10px 16px;
  color: #262626;
  border-bottom: 1px solid #f5f5f5;
  vertical-align: middle;
}
.data-table tr:hover td {
  background: #e6f4ff;
}
.row-odd td { background: #fafcff; }
.center-cell { text-align: center; }

.account-tag {
  display: inline-block;
  padding: 2px 10px;
  background: #e6f4ff;
  color: #1677ff;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.title-cell {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 700px;
  color: #262626;
}
/* 高亮 em 标签 */
.title-cell :deep(em) {
  font-style: normal;
  color: #f5222d;
  font-weight: 600;
}

.empty-cell {
  text-align: center;
  color: #bfbfbf;
  padding: 40px 0;
  font-size: 14px;
}

/* ===== 分页 ===== */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #f0f0f0;
}
.page-info { font-size: 13px; color: #8c8c8c; }
.page-btns { display: flex; gap: 4px; }
.page-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #d9d9d9;
  background: #fff;
  border-radius: 6px;
  font-size: 13px;
  color: #595959;
  cursor: pointer;
  transition: all 0.2s;
}
.page-btn:hover:not(:disabled):not(.ellipsis) {
  border-color: #1677ff;
  color: #1677ff;
}
.page-btn.active {
  background: #1677ff;
  border-color: #1677ff;
  color: #fff;
  font-weight: 600;
}
.page-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.page-btn.ellipsis { border-color: transparent; background: transparent; cursor: default; }
</style>